import { renderApp } from '.'
const widgetDivs = document.querySelectorAll('.mp-best-buy-slide')
widgetDivs.forEach((div: any) => {
  div.style.position = 'relative'

  const apiKey = div.dataset.apikey

  const config = {
    paymentMethod: div.dataset.paymentmethod,
    businessType: div.dataset.businesstype,
    propertyValue: div.dataset.propertyvalue,
    loanRequired: div.dataset.loanrequired,
    rent: div.dataset.rent,
    term: div.dataset.term,
    mortgageClass: div.dataset.mortgageclass,
    lender: div.dataset.lender,
    initialPeriod: div.dataset.initialperiod,
    fees: div.dataset.fees,
    region: div.dataset.region,
    // others: div.dataset.others,
    removeLenders: div.dataset.removelenders,
    creditQuestions: div.dataset.creditquestions,
    buildingUse: div.dataset.buildinguse,
    discountedPurchasePrice: div.dataset.discountedpurchaseprice,
    shareValue: div.dataset.sharevalue,
    percentagePurchased: div.dataset.percentagepurchased,
    enquireButtonLink: div.dataset.enquire,
    showMenuBar: div.dataset.showmenubar || 'Yes',
    showDropdownMenu: div.dataset.showdropdownmenu || 'Yes',
    showMonthlyPayment: div.dataset.showmonthlypayment || 'Yes',
    isOffset: div.dataset.isoffset,
    flexible: div.dataset.flexible,
    buyToLetHMO: div.dataset.buytolethmo,
    limitedCompany: div.dataset.limitedcompany,
    adverseCredit: div.dataset.adversecredit,
    adverseCreditRemortgage: div.dataset.adversecreditremortgage,
    newBuild: div.dataset.newbuild,
    helpToBuy: div.dataset.helptobuy,
    firstTimeBuyer: div.dataset.firsttimebuyer,
    cashback: div.dataset.cashback,
  }

  renderApp(apiKey, config, div)
})

//
